import React from "react";
import useDetectDifferentUser from "@/hooks/useDetectDifferentUser";

interface DetectDifferentAccountProps {
  children: React.ReactNode;
}

export default function DetectDifferentAccount({ children }: DetectDifferentAccountProps) {
  const { 
    DifferentAccountDialogComponent
  } = useDetectDifferentUser();
  
  return (
    <>
      {DifferentAccountDialogComponent}
      <div>{children}</div>
    </>
  );
}
